module.exports = __webpack_public_path__ + "static/media/sudoGPRthree.a21f1954.jpg";